<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">Le pagine del World Wide Web.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Cosa c’è dietro il “www” e come si costruisce un sito web? Il corso affronta
    un viaggio nel World Wide Web dal significato di Internet a come si
    struttura una pagina web e da cosa è costituita (linguaggio html, tag, CSS
    etc.), fino alla
    <span class="underline-p">costruzione di un minisito</span> personale o di
    gruppo.
  </p>
</div>

<div class="third container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/code.png"
        alt="HTML: Linguaggio di Markup"
       
        class="code"
      />
    </div>
  </div>
</div>

<div class="fourth container grid">
  <h3 class="w-700 blue-50 text-center">
    HTML, il linguaggio strutturale che sta "dietro" la pagina web.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    HTML è l’acronimo di HyperText Markup Language (“Linguaggio di contrassegno
    per gli Ipertesti”) e non è un linguaggio di programmazione. Durante il
    corso gli studenti impareranno come usare questo linguaggio di markup (“di
    marcatura”), per indicare come disporre gli elementi all’interno di una
    pagina.
  </p>
</div>

<div class="fifth container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/editor-1.png"
        alt="HTML: Linguaggio di Markup"
       
        class="editor-1"
      />
    </div>
  </div>
</div>

<div class="sixth container grid">
  <h3 class="w-700 blue-50 text-center">
    CSS. Come arricchire l’aspetto visuale di una pagina web.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    I CSS (Cascading Style Sheets) - in italiano “fogli di stile” - sono una
    serie di regole che permettono di definire l’aspetto (lo stile) che devono
    assumere gli elementi sulla pagina.
  </p>
</div>

<div class="seventh container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/editor-2.png"
        alt="HTML: Linguaggio di Markup"
       
        class="editor-2 mb-5 pb-5"
      />
      <img
        src="../../../../assets/img/structure.png"
        alt="Pagina Web"
       
        class="structure mt-xl-5 pt-xl-5"
      />
    </div>
  </div>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
